import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-lead-borrowers',
  templateUrl: './lead-borrowers.component.html',
  styleUrls: ['./lead-borrowers.component.scss']
})
export class LeadBorrowersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
